import React from "react";
import ModalAction from "~components/Modal/ModalAction";
import { WarningIcon } from "~misc/icons";

const FunnelModalShutWork = ({ show, setShow, onConfirm }) => {
  const handleSubmit = () => {
    setShow(false);
    onConfirm();
  }

  return (
    <ModalAction
      isOpen={show}
      title={
        <div className="text-center flex flex-col items-center">
          <WarningIcon fill="red" width={30} height={30} />
          Atenção
        </div>
      }
      sub={
        <p className="font-bold">
          Essa ação vai encerrar a obra <br />
          <span className="block bg-[#EEE] px-4 py-2 rounded">Deseja confirmar essa ação?</span>
        </p>
      }
      buttonOne={"Sim"}
      buttonTwo={"Não"}
      linkOne={handleSubmit}
      linkTwo={() => { setShow(false); }}
    />
  );
};

export default FunnelModalShutWork;
